import { useMutation, useQuery } from "@tanstack/react-query";
import { UseQueryExtendedOptions, useQueryHandler } from "@bn/api";
import {
  HistoricQuoteListWithRiskYieldStatistics,
  HistoricQuoteLookupParams,
  Lookup,
} from "@api/v1/model";
import {
  loadHistoricQuotesLookup,
  getHistoricQuotesLookup,
} from "@api/v1/methods";
import {
  GET_HISTORIC_QUOTES,
  GET_HISTORIC_QUOTES_LOOKUP,
} from "../../cacheKeys";

export const useLookupHistoricQuotes = (
  params: HistoricQuoteLookupParams,
  enabled = true
) =>
  useQuery({
    queryKey: [GET_HISTORIC_QUOTES, JSON.stringify(params)],
    queryFn: () => loadHistoricQuotesLookup(params),
    enabled: !!params.tickerSymbol && !!params.quoteProvider && enabled,
  });

export const useLookupHistoricQuotesOnDemand = () => {
  return useMutation({
    mutationFn: loadHistoricQuotesLookup,
    throwOnError: false,
  });
};

export const useGetHistoricQuotesLookup = (
  params: Lookup,
  options?: UseQueryExtendedOptions<
    HistoricQuoteListWithRiskYieldStatistics,
    AxiosApiError,
    HistoricQuoteListWithRiskYieldStatistics,
    (string | Lookup)[]
  >
) =>
  useQueryHandler({
    query: useQuery({
      queryKey: [GET_HISTORIC_QUOTES_LOOKUP, params],
      queryFn: () => getHistoricQuotesLookup(params),
      ...options,
    }),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
